<p-toast position="top-right"></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-wrapper">

  <!-- ─── En-tête ─────────────────────────────────── -->
  <div class="page-header">
    <div class="page-title">
      <div class="title-icon"><i class="pi pi-briefcase"></i></div>
      <div>
        <h2>Transactions</h2>
        <span class="count-badge">{{ filteredTransactions.length }} affichée(s) · {{ totalCount }} au total</span>
      </div>
    </div>
    <div class="header-actions">
      <button pButton type="button"
        [icon]="showFilters ? 'pi pi-filter-slash' : 'pi pi-filter'"
        [label]="showFilters ? 'Masquer filtres' : 'Filtres'"
        class="p-button-outlined p-button-sm"
        (click)="showFilters = !showFilters">
      </button>
      <button pButton type="button" icon="pi pi-refresh" label="Rafraîchir"
        class="p-button-outlined p-button-sm" (click)="load()">
      </button>
      <button pButton type="button" icon="pi pi-plus" label="Nouvelle transaction"
        class="p-button-sm btn-create" (click)="openCreate()">
      </button>

      <!-- Inputs fichiers cachés -->
      <input #csvImportInput type="file" accept=".csv,.txt" hidden
        (change)="onCsvFileSelected($event)" />
      <input #mobileDeleteExcelInput type="file" accept=".xlsx,.xlsm" hidden
        (change)="onMobileDeleteExcelSelected($event)" />
    </div>
  </div>

  <!-- ─── Panneau filtres ──────────────────────────── -->
  <div class="filter-panel" *ngIf="showFilters">
    <div class="search-wrap">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Réf, objet, assureur…"
          [(ngModel)]="search" style="width:220px" />
      </span>
    </div>

    <div class="filter-sep"></div>

    <div class="filter-group">
      <label>Phase</label>
      <p-dropdown [options]="phaseFilterOptions" [(ngModel)]="selectedPhase"
        optionLabel="label" optionValue="value"
        (onChange)="load()"
        [style]="{ minWidth:'220px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Origine</label>
      <p-dropdown [options]="origineFilterOptions" [(ngModel)]="selectedOrigine"
        optionLabel="label" optionValue="value"
        [showClear]="true" placeholder="Toutes"
        [style]="{ minWidth:'175px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group" *ngIf="isAdmin">
      <label>Conseiller</label>
      <p-dropdown [options]="usersFilter" [(ngModel)]="selectedUserId"
        optionLabel="label" optionValue="value"
        [filter]="true" filterBy="label"
        [showClear]="true" placeholder="Tous"
        [style]="{ minWidth:'170px' }" appendTo="body">
      </p-dropdown>
    </div>

    <div class="filter-group">
      <label>Période de création</label>
      <p-calendar [(ngModel)]="dateRange" selectionMode="range"
        [readonlyInput]="true" dateFormat="dd/mm/yy"
        placeholder="Du … au …" appendTo="body"
        [showButtonBar]="true" [style]="{ minWidth:'200px' }">
      </p-calendar>
    </div>

    <button *ngIf="hasActiveFilters" pButton type="button"
      icon="pi pi-times" label="Effacer les filtres"
      class="p-button-sm p-button-text p-button-secondary"
      (click)="clearFilters()">
    </button>
  </div>

  <!-- ─── Chip filtre contact ──────────────────────── -->
  <div *ngIf="contactId">
    <span class="contact-chip">
      <i class="pi pi-user"></i>
      Filtré sur le contact #{{ contactId }}
      <button pButton type="button" icon="pi pi-times"
        class="p-button-text p-button-sm p-button-rounded"
        style="width:1.4rem;height:1.4rem"
        (click)="clearContactFilter()">
      </button>
    </span>
  </div>

  <!-- ─── Barre d'actions unifiée ─────────────────── -->
  <div class="action-bar">
    <span class="bulk-count" [class.has-selection]="selected.length">
      <i class="pi pi-check-square"></i>
      {{ selected.length }} sélectionnée(s)
    </span>
    <button *ngIf="selected.length" pButton type="button" icon="pi pi-times" label="Désélectionner"
      class="p-button-sm p-button-text" (click)="selected = []; selectedAction = null">
    </button>
    <span class="bulk-sep"></span>

    <p-dropdown [options]="actionOptions" [(ngModel)]="selectedAction"
      optionLabel="label" optionValue="value"
      placeholder="Choisir une action…" [showClear]="true"
      appendTo="body" [style]="{ minWidth:'240px' }">
      <ng-template let-opt pTemplate="item">
        <span><i [class]="opt.icon" style="margin-right:.5rem"></i>{{ opt.label }}</span>
      </ng-template>
    </p-dropdown>

    <!-- Sous-champ : phase -->
    <p-dropdown *ngIf="selectedAction === 'phase'"
      [options]="phaseEditOptions" [(ngModel)]="bulkPhase"
      placeholder="Nouvelle phase…"
      appendTo="body" [style]="{ minWidth:'210px' }">
    </p-dropdown>

    <!-- Sous-champ : conseiller -->
    <p-dropdown *ngIf="selectedAction === 'assign'"
      [options]="usersFilter" [(ngModel)]="selectedAssignUserId"
      optionLabel="label" optionValue="value"
      [filter]="true" filterBy="label"
      placeholder="Conseiller cible…"
      appendTo="body" [style]="{ minWidth:'200px' }">
    </p-dropdown>

    <button pButton type="button" label="Exécuter" icon="pi pi-play"
      class="p-button-sm"
      [disabled]="!canExecuteAction()"
      [loading]="isBulkBusy()"
      (click)="executeAction()">
    </button>

    <span *ngIf="selectedAction && actionNeedsSelection(selectedAction) && !selected.length"
      class="action-hint">
      <i class="pi pi-info-circle"></i> Sélectionnez au moins une ligne
    </span>
  </div>

  <!-- ─── Spinner ──────────────────────────────────── -->
  <div *ngIf="loading" class="spinner-wrap">
    <p-progressSpinner [style]="{width:'48px',height:'48px'}"></p-progressSpinner>
  </div>

  <!-- ─── Tableau ──────────────────────────────────── -->
  <div class="table-card" *ngIf="!loading">
    <p-table
      [value]="filteredTransactions"
      [(selection)]="selected"
      dataKey="id"
      [paginator]="true"
      [rows]="15"
      [rowsPerPageOptions]="[15, 25, 50, 100]"
      styleClass="p-datatable-sm p-datatable-gridlines"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width:3rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          <th style="min-width:210px">Client</th>
          <th style="min-width:215px">Phase</th>
          <th style="min-width:185px">Profil Mutuelle</th>
          <th style="min-width:165px">Devis</th>
          <th style="min-width:130px">Statut contrat</th>
          <th style="min-width:100px">Créée le</th>
          <th style="width:155px; text-align:center">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-t>
        <tr>
          <!-- Case à cocher -->
          <td><p-tableCheckbox [value]="t"></p-tableCheckbox></td>

          <!-- Client + Référence -->
          <td>
            <div class="client-cell" *ngIf="t.contact; else noClient">
              <div class="client-avatar" [style.background]="contactAvatarColor(t)">{{ contactInitials(t) }}</div>
              <div class="client-info">
                <div class="client-name">{{ contactName(t) }}</div>
                <div class="ref-cell-inline">{{ t.reference || t.project_id }}</div>
                <div class="client-meta">
                  <span *ngIf="t.contact.mobile"><i class="pi pi-mobile"></i>{{ t.contact.mobile }}</span>
                  <span *ngIf="!t.contact.mobile && t.contact.ville">{{ t.contact.ville }}</span>
                </div>
              </div>
            </div>
            <ng-template #noClient>
              <div class="client-cell">
                <div class="client-avatar" style="background:#e2e8f0;color:#94a3b8">?</div>
                <div class="client-info">
                  <div class="ref-cell-inline">{{ t.reference || t.project_id }}</div>
                </div>
              </div>
            </ng-template>
          </td>

          <!-- Phase inline dropdown + tag -->
          <td>
            <div class="phase-cell">
              <p-tag [value]="t.phase_transaction || '—'"
                [severity]="phaseSeverity(t.phase_transaction)"
                [style]="{ fontSize:'.72rem', padding:'.2rem .6rem', maxWidth:'100%', whiteSpace:'normal', textAlign:'left' }">
              </p-tag>
              <p-dropdown
                [options]="phaseEditOptions"
                [(ngModel)]="t.phase_transaction"
                (onChange)="updateField(t, 'phase_transaction', $event.value)"
                [showClear]="true" placeholder="Changer…"
                appendTo="body"
                [style]="{ minWidth:'200px', fontSize:'.8rem' }">
              </p-dropdown>
            </div>
          </td>

          <!-- Mutuelle Santé -->
          <td>
            <div class="pret-cell">
              <div class="pret-amount" *ngIf="t.nb_enfant_assure != null">
                Enfants : {{ t.nb_enfant_assure }}
              </div>
              <div class="pret-meta">
                <span *ngIf="t.deplacement_professionnel"><i class="pi pi-car" title="Déplacement Pro"></i></span>
                <span *ngIf="t.port_charge"><i class="pi pi-box" title="Port de charge"></i></span>
                <span *ngIf="t.travaille_en_hauteur"><i class="pi pi-arrow-up" title="Travail en hauteur"></i></span>
              </div>
              <span *ngIf="t.nb_enfant_assure == null && !t.deplacement_professionnel && !t.port_charge && !t.travaille_en_hauteur" style="color:#cbd5e1">—</span>
            </div>
          </td>

          <!-- Devis -->
          <td>
            <div class="devis-mini">
              <span class="devis-mini-badge" [class.sent]="hasDevis(t)">
                <i class="pi" [class.pi-check-circle]="hasDevis(t)" [class.pi-clock]="!hasDevis(t)"></i>
                {{ hasDevis(t) ? (t.nbre_devis_envoyes || '✓') : '—' }}
              </span>
              <div class="devis-best" *ngIf="t.assureur_moins_cher || t.tarif_mensuel_moins_cher != null">
                <i class="pi pi-star-fill"></i>
                <span class="db-name">{{ t.assureur_moins_cher || '—' }}</span>
                <span class="db-price" *ngIf="t.tarif_mensuel_moins_cher != null">
                  {{ t.tarif_mensuel_moins_cher | number:'1.0-0' }} €/m
                </span>
              </div>
            </div>
          </td>

          <td style="text-align:center">
            <ng-container *ngIf="t.contact">
              <p-dropdown
                [options]="statutLeadOptions"
                [(ngModel)]="t.contact.statut_du_lead"
                (onChange)="updateContactField(t.contact, 'statut_du_lead', $event.value)"
                [showClear]="true" placeholder="—"
                appendTo="body" [style]="{ minWidth:'120px' }">
              </p-dropdown>
            </ng-container>
          </td>

          <!-- Date création -->
          <td>
            <div *ngIf="t.date_creation_transaction" style="font-size:.8rem;color:#64748b;line-height:1.4">
              <div>{{ t.date_creation_transaction | date:'dd/MM/yyyy' }}</div>
              <div style="font-size:.72rem;color:#94a3b8">{{ t.date_creation_transaction | date:'HH:mm' }}</div>
            </div>
            <span *ngIf="!t.date_creation_transaction" style="color:#cbd5e1">—</span>
          </td>

          <!-- Actions -->
          <td>
            <div class="row-actions">
              <button pButton type="button" icon="pi pi-eye"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Détails" tooltipPosition="top"
                (click)="openDetails(t)">
              </button>
              <button pButton type="button" icon="pi pi-folder-open"
                class="p-button-rounded p-button-text p-button-sm btn-form"
                pTooltip="Ouvrir le formulaire" tooltipPosition="top"
                [disabled]="openingForm"
                (click)="openInForm(t)">
              </button>
              <button pButton type="button" icon="pi pi-copy"
                class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Dupliquer" tooltipPosition="top"
                [disabled]="duplicatingId === t.id || !t.project_id"
                (click)="duplicateOne(t)">
              </button>
              <button pButton type="button" icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-sm p-button-danger"
                pTooltip="Supprimer" tooltipPosition="top"
                (click)="deleteOne(t)">
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="empty">
            <i class="pi pi-inbox"></i>
            Aucune transaction trouvée.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

</div>

<!-- ─── Dialog Détails : 2 panneaux (contact + transaction) ─── -->
<p-dialog
  header="Détails de la transaction"
  [(visible)]="detailVisible"
  [modal]="true"
  [style]="{ width:'1150px', maxWidth:'97vw' }"
  [dismissableMask]="true"
>
  <div *ngIf="selectedTransaction as t" class="split-view">

  <!-- ░░░ Colonne gauche : fiche contact ░░░ -->
  <div class="split-col contact-col details">
    <div class="col-head">
      <div class="contact-avatar lg" [style.background]="'#6366f1'">
        {{ selectedContact ? initials(selectedContact) : '?' }}
      </div>
      <div>
        <div class="col-head-title">{{ selectedContact ? fullName(selectedContact) : 'Contact' }}</div>
        <div class="col-head-sub">{{ selectedContact?.reference || ('#' + t.contact_id) }}</div>
      </div>
    </div>

    <div *ngIf="loadingContact" class="mini-spinner">
      <p-progressSpinner [style]="{width:'34px',height:'34px'}"></p-progressSpinner>
    </div>

    <ng-container *ngIf="!loadingContact && selectedContact as c">
      <!-- Actions rapides -->
        <div class="quick-actions">
          <button pButton type="button" icon="pi pi-phone" label="Appeler"
            class="p-button-sm p-button-outlined" style="color:#16a34a;border-color:#16a34a"
            [disabled]="!c.mobile && !c.fixe" (click)="callContact(c)"></button>
          <button pButton type="button" label="SMS"
            class="p-button-sm p-button-outlined" style="color:#0891b2;border-color:#0891b2"
            [disabled]="!c.mobile" (click)="smsContact(c)"></button>
          <button pButton type="button" icon="pi pi-comment" label="Commentaire"
            class="p-button-sm p-button-outlined" style="color:#6366f1;border-color:#6366f1"
            pTooltip="{{ t.commentaire || 'Aucun commentaire' }}" tooltipPosition="top"></button>
        </div>

      <h4>Assuré 1</h4>
      <div class="grid">
        <div><label>Civilité</label><span>{{ c.civilite || '—' }}</span></div>
        <div><label>Nom</label><span>{{ c.nom || '—' }}</span></div>
        <div><label>Prénom</label><span>{{ c.prenom || '—' }}</span></div>
        <div><label>Date naissance</label><span>{{ c.date_naissance ? (c.date_naissance | date:'dd/MM/yyyy') : '—' }}</span></div>
        <div><label>Mobile</label><span>{{ c.mobile || '—' }}</span></div>
        <div><label>Fixe</label><span>{{ c.fixe || '—' }}</span></div>
        <div><label>Email</label><span>{{ c.email || '—' }}</span></div>
        <div><label>Ville</label><span>{{ c.ville || '—' }}</span></div>
        <div><label>Code postal</label><span>{{ c.code_postal || '—' }}</span></div>
        <div><label>Profession</label><span>{{ c.profession_exacte || '—' }}</span></div>
        <div><label>Statut lead</label><span>{{ c.statut_du_lead || '—' }}</span></div>
        <div><label>Type contact</label><span>{{ c.type_contact || '—' }}</span></div>
        <div><label>Cycle de vie</label><span>{{ c.cycle_de_vie || '—' }}</span></div>
        <div><label>Fumeur</label><span>{{ c.fumeur ? 'Oui' : 'Non' }}</span></div>
      </div>

      <ng-container *ngIf="c.est_assure2">
        <h4>Assuré 2</h4>
        <div class="grid">
          <div><label>Civilité</label><span>{{ c.assure2_civilite || '—' }}</span></div>
          <div><label>Nom</label><span>{{ c.assure2_nom || '—' }}</span></div>
          <div><label>Prénom</label><span>{{ c.assure2_prenom || '—' }}</span></div>
          <div><label>Date naissance</label><span>{{ c.assure2_date_naissance ? (c.assure2_date_naissance | date:'dd/MM/yyyy') : '—' }}</span></div>
          <div><label>Mobile</label><span>{{ c.assure2_mobile || '—' }}</span></div>
          <div><label>Email</label><span>{{ c.assure2_email || '—' }}</span></div>
          <div><label>Profession</label><span>{{ c.assure2_profession_exacte || '—' }}</span></div>
          <div><label>Fumeur</label><span>{{ c.assure2_fumeur ? 'Oui' : 'Non' }}</span></div>
        </div>
      </ng-container>
    </ng-container>

    <div *ngIf="!loadingContact && !selectedContact" class="mini-empty">
      <i class="pi pi-user-minus"></i>
      Fiche contact indisponible.
    </div>
  </div>

  <!-- ░░░ Colonne droite : détails transaction ░░░ -->
  <div class="split-col trans-col details">

    <!-- Actions rapides -->
    <div class="quick-actions">
      <button pButton type="button" icon="pi pi-folder-open" label="Ouvrir le formulaire"
        class="p-button-sm p-button-outlined"
        style="color:#7c3aed;border-color:#7c3aed"
        [disabled]="openingForm"
        (click)="openInForm(t)">
      </button>
    </div>

    <!-- ── Carte Devis & Contrat (dynamique) ── -->
    <div class="devis-card">
      <!-- En-tête statut -->
      <div class="devis-card-head">
        <span class="devis-card-status" [class.devis-card-status--sent]="t.devis_envoye || t.nbre_devis_envoyes">
          <i class="pi" [class.pi-check-circle]="t.devis_envoye || t.nbre_devis_envoyes"
                        [class.pi-clock]="!t.devis_envoye && !t.nbre_devis_envoyes"></i>
          {{ (t.devis_envoye || t.nbre_devis_envoyes) ? 'Devis envoyé' : 'Pas encore envoyé' }}
        </span>
        <span *ngIf="t.nbre_devis_envoyes" class="devis-card-count">{{ t.nbre_devis_envoyes }} envoyé(s)</span>
        <span *ngIf="t.date_envoi_devis" class="devis-card-date">
          <i class="pi pi-calendar"></i>{{ t.date_envoi_devis | date:'dd/MM/yyyy' }}
        </span>
        <span class="devis-card-spacer"></span>
        <ng-container *ngIf="t.contact">
          <span *ngIf="t.contact.statut_du_lead" class="devis-card-contrat"
            [class.contrat-ok]="t.contact.statut_du_lead === 'En cours - Devis Envoyé'">
            <i class="pi pi-file-check"></i> {{ t.contact.statut_du_lead }}
          </span>
        </ng-container>
      </div>

      <!-- Une carte par devis envoyé (JSON historique) -->
      <ng-container *ngIf="parseDevisHistory(t) as history">
        <div *ngIf="history.length" class="devis-quotes-list">
          <div *ngFor="let d of history; let i = index" class="devis-quote-card">
            <div class="dqc-top">
              <span class="dqc-num">#{{ i + 1 }}</span>
              <span class="dqc-assureur">{{ d.assureur }}</span>
              <span class="dqc-date">{{ d.date | date:'dd/MM/yyyy' }}</span>
            </div>
            <div class="dqc-body">
              <div *ngIf="d.montant_mensuel">
                <label>Mensuel</label>
                <span class="dqc-price">{{ d.montant_mensuel | number:'1.0-2' }} €</span>
              </div>
              <div *ngIf="d.montant_total">
                <label>Total</label>
                <span>{{ d.montant_total | number:'1.0-2' }} €</span>
              </div>
              <div *ngIf="d.label">
                <label>Produit</label><span>{{ d.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Fallback texte si données pas encore en JSON -->
        <div *ngIf="!history.length && t.nom_assureurs" class="devis-card-body">
          <div><label>Assureurs</label><span>{{ t.nom_assureurs }}</span></div>
          <div *ngIf="t.cout_mensuel_assurance != null">
            <label>Mensuel</label>
            <span class="devis-price">{{ t.cout_mensuel_assurance | number:'1.0-2' }} €/mois</span>
          </div>
        </div>
      </ng-container>

      <!-- Contrat souscrit -->
      <div class="devis-card-body devis-card-body--contract"
        *ngIf="t.assureur || t.numero_contrat || t.motif_refus">
        <div *ngIf="t.assureur"><label>Assureur souscrit</label><span>{{ t.assureur }}</span></div>
        <div *ngIf="t.numero_contrat"><label>N° contrat</label><span>{{ t.numero_contrat }}</span></div>
        <div *ngIf="t.motif_refus"><label>Motif refus</label><span class="text-danger">{{ t.motif_refus }}</span></div>
      </div>

      <!-- Édition rapide -->
      <div class="devis-card-edit">
        <label class="devis-card-edit-label">Statut du lead</label>
        <ng-container *ngIf="t.contact">
          <p-dropdown [options]="statutLeadOptions" [(ngModel)]="t.contact.statut_du_lead"
            (onChange)="updateContactField(t.contact, 'statut_du_lead', $event.value)"
            [showClear]="true" placeholder="—"
            appendTo="body" [style]="{ minWidth:'140px', fontSize:'.82rem' }">
          </p-dropdown>
        </ng-container>
        <label class="devis-card-edit-label" style="margin-left:.75rem">Devis envoyé</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="t.devis_envoye"
          (onChange)="updateField(t, 'devis_envoye', $event.value)"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ minWidth:'100px', fontSize:'.82rem' }">
        </p-dropdown>
      </div>
    </div>

    <h4>Suivi</h4>
    <div class="grid">
      <div><label>Référence</label><span>{{ t.reference || t.project_id }}</span></div>
      <div><label>Phase</label><span>{{ t.phase_transaction || '—' }}</span></div>
      <div><label>Date création</label><span>{{ t.date_creation_transaction ? (t.date_creation_transaction | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date contact</label><span>{{ t.date_contact ? (t.date_contact | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date d'effet</label><span>{{ t.date_effective ? (t.date_effective | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date envoi devis</label><span>{{ t.date_envoi_devis ? (t.date_envoi_devis | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Date dern. demande info</label><span>{{ t.date_derniere_demande_information ? (t.date_derniere_demande_information | date:'dd/MM/yyyy') : '—' }}</span></div>
      <div><label>Résultat appel</label><span>{{ t.resultat_appel || '—' }}</span></div>
      <div><label>Revenu</label><span>{{ t.revenu != null ? (t.revenu | number:'1.0-2') + ' €' : '—' }}</span></div>
      <div><label>Commentaire</label><span>{{ t.commentaire || '—' }}</span></div>
    </div>

    <h4>Contrat souscrit</h4>
    <div class="grid">
      <div><label>N° contrat</label><span>{{ t.numero_contrat || '—' }}</span></div>
      <div><label>Nb contrats</label><span>{{ t.nb_contrat ?? '—' }}</span></div>
      <div><label>Produit</label><span>{{ t.produit || '—' }}</span></div>
      <div><label>Nom produit</label><span>{{ t.nom_produit || '—' }}</span></div>
      <div><label>Précédent assureur</label><span>{{ t.precedent_assureur || '—' }}</span></div>
    </div>



    <h4>Risque Assuré 1</h4>
    <div class="grid">
      <div><label>Déplacement pro</label><span>{{ t.deplacement_professionnel || '—' }}</span></div>
      <div><label>Travaille en hauteur</label><span>{{ t.travaille_en_hauteur || '—' }}</span></div>
      <div><label>Port de charge</label><span>{{ t.port_charge ? 'Oui' : 'Non' }}</span></div>
      <div><label>Nb enfants assurés</label><span>{{ t.nb_enfant_assure ?? '—' }}</span></div>
    </div>


  </div>

  </div>
</p-dialog>

<!-- ─── Dialog Nouvelle transaction ──────────────────── -->
<p-dialog
  header="Nouvelle transaction"
  [(visible)]="createVisible"
  [modal]="true"
  [style]="{ width:'900px', maxWidth:'97vw' }"
  [contentStyle]="{ maxHeight:'78vh', overflowY:'auto' }"
  [dismissableMask]="true"
>
  <div class="create-form">

    <!-- ══ Contact ══ -->
    <div class="create-section">Contact lié <span class="req">*</span></div>
    <div class="create-grid">
      <div class="create-field cf-full">
        <label>Contact</label>
        <p-dropdown [options]="contactOptions" [(ngModel)]="newTransaction.contact_id"
          [filter]="true" filterBy="label" [loading]="loadingContactOpts"
          placeholder="Rechercher un contact…"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
    </div>

    <!-- ══ Pipeline / Suivi ══ -->
    <div class="create-section">Pipeline & Suivi</div>
    <div class="create-grid">
      <div class="create-field cf-wide">
        <label>Phase</label>
        <p-dropdown [options]="phaseEditOptions" [(ngModel)]="newTransaction.phase_transaction"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Date contact</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_contact" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date d'effet</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_effective" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date envoi devis</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_envoi_devis" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Date dernière demande info</label>
        <input pInputText type="date" [(ngModel)]="newTransaction.date_derniere_demande_information" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Résultat appel</label>
        <p-dropdown [options]="resultatAppelOptions" [(ngModel)]="newTransaction.resultat_appel"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field cf-wide">
        <label>Commentaire</label>
        <input pInputText [(ngModel)]="newTransaction.commentaire" placeholder="Notes…" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Revenu (€)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.revenu" placeholder="0" style="width:100%" />
      </div>
    </div>


    <!-- ══ Risque ══ -->
    <div class="create-section">Risque Assuré 1</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Déplacement professionnel</label>
        <p-dropdown [options]="deplacementOptions" [(ngModel)]="newTransaction.deplacement_professionnel"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Travaille en hauteur</label>
        <p-dropdown [options]="travailEnHauteurOptions" [(ngModel)]="newTransaction.travaille_en_hauteur"
          optionLabel="label" optionValue="value"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Port de charge</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newTransaction.port_charge"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Nb enfants assurés</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.nb_enfant_assure" placeholder="0" style="width:100%" />
      </div>
    </div>



    <!-- ══ Devis / Contrat ══ -->
    <div class="create-section">Devis & Contrat</div>
    <div class="create-grid">
      <div class="create-field">
        <label>Nb devis envoyés</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.nbre_devis_envoyes" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Devis envoyé</label>
        <p-dropdown [options]="ouiNonOptions" [(ngModel)]="newTransaction.devis_envoye"
          optionLabel="label" optionValue="value"
          appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field cf-wide">
        <label>Noms assureurs proposés</label>
        <input pInputText [(ngModel)]="newTransaction.nom_assureurs" placeholder="Assureur 1, Assureur 2…" style="width:100%" />
      </div>
      <div class="create-field">
        <label>N° devis</label>
        <input pInputText [(ngModel)]="newTransaction.numero_devis" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>N° contrat</label>
        <input pInputText [(ngModel)]="newTransaction.numero_contrat" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Statut contrat</label>
        <p-dropdown [options]="statutContratOptions" [(ngModel)]="newTransaction.statut_contrat"
          [showClear]="true" placeholder="—" appendTo="body" [style]="{ width:'100%' }">
        </p-dropdown>
      </div>
      <div class="create-field">
        <label>Nb contrats</label>
        <input pInputText type="number" [(ngModel)]="newTransaction.nb_contrat" placeholder="0" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Assureur souscrit</label>
        <input pInputText [(ngModel)]="newTransaction.assureur" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Produit</label>
        <input pInputText [(ngModel)]="newTransaction.produit" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Nom produit</label>
        <input pInputText [(ngModel)]="newTransaction.nom_produit" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Coût mensuel assurance (€)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.cout_mensuel_assurance" placeholder="0.00" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Coût total assurance (€)</label>
        <input pInputText type="number" step="0.01" [(ngModel)]="newTransaction.cout_total_assurance" placeholder="0.00" style="width:100%" />
      </div>
      <div class="create-field">
        <label>Précédent assureur</label>
        <input pInputText [(ngModel)]="newTransaction.precedent_assureur" placeholder="—" style="width:100%" />
      </div>
      <div class="create-field cf-wide">
        <label>Motif refus</label>
        <input pInputText [(ngModel)]="newTransaction.motif_refus" placeholder="—" style="width:100%" />
      </div>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <div style="display: flex; justify-content: space-between; width: 100%;">
      <button pButton type="button" label="Remplir (Test)" icon="pi pi-bolt"
        class="p-button-text p-button-info p-button-sm" (click)="fillExampleData()">
      </button>
      <div>
        <button pButton type="button" label="Annuler" icon="pi pi-times"
          class="p-button-text p-button-secondary" (click)="createVisible = false">
        </button>
        <button pButton type="button" label="Créer la transaction" icon="pi pi-check"
          class="p-button-sm btn-create" [disabled]="saving" (click)="saveTransaction()">
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- ── SMS : relecture avant envoi (via Ringover) ── -->
<p-dialog
  header="Vérifier et envoyer le SMS"
  [(visible)]="smsDialogVisible"
  [modal]="true"
  [style]="{ width:'560px', maxWidth:'96vw' }"
  [dismissableMask]="true">
  <div *ngIf="smsDialogContact" style="display:flex;flex-direction:column;gap:10px">
    <div style="display:flex;align-items:center;gap:8px;color:#555">
      <i class="pi pi-mobile"></i>
      <div>
        <div style="font-weight:600">{{ fullName(smsDialogContact) }}</div>
        <div style="font-size:12px;color:#888">{{ smsDialogPhone }}</div>
      </div>
    </div>
    <div style="display:flex;align-items:center;justify-content:space-between;font-size:12px;color:#555">
      <span><i class="pi pi-pencil"></i> Message SMS</span>
      <span [style.color]="smsDialogContent.length > 800 ? '#d97706' : '#888'">
        {{ smsDialogContent.length }} caractères
      </span>
    </div>
    <textarea [(ngModel)]="smsDialogContent" rows="12"
      style="width:100%;box-sizing:border-box;resize:vertical;border:1px solid #cfd8dc;border-radius:8px;padding:8px;font:inherit"
      placeholder="Rédigez votre message…"></textarea>
    <div style="font-size:12px;color:#888">
      <i class="pi pi-info-circle"></i>
      Vous pouvez modifier le message avant de l'envoyer. L'envoi est effectué via Ringover.
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annuler" icon="pi pi-times"
      class="p-button-text p-button-secondary"
      (click)="smsDialogVisible = false" [disabled]="smsDialogSending">
    </button>
    <button pButton type="button" label="Envoyer le SMS" icon="pi pi-send"
      class="p-button-sm" style="background:#0891b2;border-color:#0891b2"
      [disabled]="smsDialogSending || !smsDialogContent.trim()"
      [loading]="smsDialogSending"
      (click)="sendSmsFromDialog()">
    </button>
  </ng-template>
</p-dialog>
